import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable()
export class DatePickerParser extends NgbDateParserFormatter {
  public parse(value: string): NgbDateStruct {
    if (value) {
      const momentDate: moment.Moment = moment(value.trim(), ['DD/MM/YYYY', 'DD-MM-YYYY', 'DDMMYYYY'], 'fr', true);
      if (momentDate.isValid()) {
        const parsedDate: moment.MomentObjectOutput = momentDate.toObject();
        return {
          year: parsedDate.years,
          month: parsedDate.months + 1,
          day: parsedDate.date,
        };
      }
    }
    return { year: 0, month: 0, day: 0 };
  }

  public format(date: NgbDateStruct): string {
    if (date) {
      const momentDate: moment.Moment = moment({
        year: date.year,
        month: date.month - 1,
        day: date.day,
        hour: 12,
        minute: 0,
      });
      if (momentDate.isValid()) {
        return momentDate.format('DD/MM/YYYY');
      }
    }
    return '';
  }
}
